import { render, staticRenderFns } from "./ActionPersonReceiver.vue?vue&type=template&id=5dbb77ca"
import script from "./ActionPersonReceiver.vue?vue&type=script&lang=js"
export * from "./ActionPersonReceiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports